import jsonToFormData from 'json-form-data';
import { useQuery } from '@tanstack/react-query';

import { get, api } from '../../lib/api';

const formatDate = newDate => {
  if (typeof newDate === 'string') {
    const year = newDate.substr(0, 4);
    const month = parseInt(newDate.substr(5, 2), 10) - 1;
    const day = newDate.substr(8, 2);
    return new Date(year, month, day);
  }
  return newDate;
};

const transformRaffle = raffle => {
  const values = {
    raffle: {
      id: raffle.id,
      starts_at: raffle.startsAt,
      ends_at: raffle.endsAt,
      other_info: raffle.otherInfo,
    },
  };

  const valuesTransformed = jsonToFormData(values);

  raffle.prizes.forEach(element => {
    valuesTransformed.append('raffle[prizes][]', element);
  });

  return valuesTransformed;
};

export const useGetRaffle = ({ sortBy, sortDirection }) => {
  const params = {
    sort_by: sortBy,
    sort_direction: sortDirection,
  };

  const { data = { data: {} } } = useQuery(
    ['getRaffle', params],
    () => get('/api/client_admin/prizes', params),
    {
      keepPreviousData: true,
    },
  );

  const response = data;

  if (response.startsAt) {
    response.startsAt = formatDate(response.startsAt);
  }

  if (response.endsAt) {
    response.endsAt = formatDate(response.endsAt);
  }

  return response;
};

export const updateRaffle = raffle => {
  const valuesTransformed = transformRaffle(raffle);

  return api({
    method: 'put',
    url: `/api/client_admin/prizes/${raffle.id}`,
    headers: { 'Content-Type': 'multipart/form-data' },
    data: valuesTransformed,
  });
};

export const endEarly = () => {
  return api({
    method: 'patch',
    url: `/api/client_admin/prizes/end_early`,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const cancel = () => {
  return api({
    method: 'delete',
    url: `/api/client_admin/prizes/cancel`,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const startNew = () => {
  return api({
    method: 'delete',
    url: `/api/client_admin/prizes/start_new`,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const saveDraft = raffle => {
  const valuesTransformed = transformRaffle(raffle);

  return api({
    method: 'post',
    url: `/api/client_admin/prizes/save_draft`,
    headers: { 'Content-Type': 'multipart/form-data' },
    data: valuesTransformed,
  });
};

export const start = raffle => {
  const valuesTransformed = transformRaffle(raffle);

  return api({
    method: 'post',
    url: `/api/client_admin/prizes/start`,
    headers: { 'Content-Type': 'multipart/form-data' },
    data: valuesTransformed,
  });
};

export const pickWinners = ({ winnersNumber }) => {
  return api.post(`/api/client_admin/prizes/pick_winners/${winnersNumber}`);
};

export const repickWinner = ({ userId }) => {
  return api.post(`/api/client_admin/prizes/repick_winner/${userId}`);
};

export const deleteWinner = ({ userId }) => {
  return api.delete(`/api/client_admin/prizes/delete_winner/${userId}`);
};
